import axios from "axios";

// Global response interceptor: when the API rejects the session (token expired,
// tampered, or the admin account was disabled), log the user out and send them
// to /login. Registered on the default axios instance so it covers every raw
// axios call across the app (NTS tables, common_api, etc.). It is intentionally
// NOT attached to authInstance, so the expected 401 from verifyToken on boot
// keeps being handled by App.js without triggering a redirect.

// Guard so N parallel failing requests don't each fire a redirect.
let sessionExpiredHandled = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const onLoginPage =
      typeof window !== "undefined" &&
      window.location?.pathname?.startsWith("/login");

    if ((status === 401 || status === 403) && !sessionExpiredHandled && !onLoginPage) {
      sessionExpiredHandled = true;
      localStorage.removeItem("userData");
      // 403 = account disabled, 401 = expired/invalid token.
      const reason = status === 403 ? "disabled" : "expired";
      // Full reload guarantees clean auth/React state; App.js then routes to /login.
      window.location.assign(`/login?session=${reason}`);
    }

    return Promise.reject(error);
  }
);
